import { TreeSelect, TreeSelectProps } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { categoriesFetch } from "@/apis/product";
import { ProductCategory } from "@/types/product";

interface SelectCategoryProps extends Omit<TreeSelectProps, 'treeData' | 'loading'> {
  value?: string;
  onChange?: (value: string) => void;
  /** 是否按组织类目权限过滤（默认 false） */
  cateOrgPermission?: boolean;
}

const SelectCategory: FC<SelectCategoryProps> = ({
  value,
  onChange,
  cateOrgPermission,
  ...props
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState<Array<ProductCategory>>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // 仅在下拉打开且尚无数据时请求
    if (!open || treeData.length > 0) return;
    const controller = new AbortController();
    setLoading(true);
    categoriesFetch({ controller }, cateOrgPermission)
      .then(({ body }) => {
        setTreeData(body ?? []);
      })
      .catch(() => {
        setTreeData([]);
      })
      .finally(() => {
        setLoading(false);
      });
    return () => controller.abort();
  }, [open, treeData.length, cateOrgPermission]);

  return (
    <TreeSelect
      showSearch
      style={{ width: "100%" }}
      value={value}
      open={open}
      onDropdownVisibleChange={setOpen}
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      placeholder={t("category.selCategory")}
      allowClear
      loading={loading}
      treeDefaultExpandAll
      onChange={onChange}
      treeData={treeData}
      fieldNames={{
        value: "id",
        label: "name",
        children: "subs",
      }}
      treeNodeFilterProp="name"
      {...props}
    />
  );
};

export default SelectCategory;
